const t=(t,e)=>{const o=getComputedStyle(t).getPropertyValue(e);return""===o?null:o};export{t as getCSSProp};
//# sourceMappingURL=custom-properties.js.map
